// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"17f78d51","455":"cd207f76","977":"ad9272b5"}[chunkId] + ".chunk.js";
};